import { Controller } from "@hotwired/stimulus";

// Client-side only on purpose: a reload or a turbo-stream replace of the overlay re-shows the scrim, so a
// chart whose filter state just changed is always seen rather than staying collapsed from a prior view.
// The corner warning badge is always rendered and reaches this controller through an outlet, so a dismissed
// scrim can always be brought back.
export default class extends Controller {
  static targets = ["scrim"];

  dismiss() {
    this.scrimTarget.classList.add("hidden");
  }

  toggle() {
    this.scrimTarget.classList.toggle("hidden");
  }
}
